<template>
  <div class="Home-box">
    <div class="HomeView-container">
      <!-- <div class="bg-Mask"></div> -->
      <div class="body">
        <img :src="logo" alt="" />
        <h1><strong>内江数循</strong></h1>
        <h2>数据要素技术与服务提供商</h2>
        <div class="btnList">
          <a href="#bottom">咨询合作</a>
          <a @click.prevent="handlemk">数据集超市</a>
        </div>
      </div>
      <div class="mouse">
        <i class="iconfont icon-shubiao"></i>
        <p>下拉查看更多</p>
      </div>
    </div>
    <div class="Content">
      <div class="hxcp">
        <div class="hxcp-title">核心产品</div>
        <div class="products-List">
          <div
            class="product-item"
            v-for="(it, index) in data"
            :key="index"
            @mouseenter="handlehover(index)"
            @click="handlepush(it.go)"
          >
            <img class="bgImg" :src="it.img" alt="" />
            <p class="item-title">{{ it.title }}</p>
            <p class="item-content">{{ it.content }}</p>
          </div>
        </div>
      </div>
      <Serve />
      <Hzhb />
    </div>
  </div>
</template>

<script>
import Serve from "./components/Serve.vue";
import Hzhb from "./components/Hzhb.vue";
import img1 from "@/assets1/首页_slices (1)/编组 5.png";
import img2 from "@/assets1/首页_slices (1)/编组 5(1).png";
import img3 from "@/assets1/首页_slices (1)/公益商城未选中.png";
import logo from "@/assets1/首页_slices (1)/编组 37备份.png";
import hoverimg1 from "@/assets1/首页_slices (1)/编组 5选中.png";
import hoverimg2 from "@/assets1/首页_slices (1)/编组 5(1)选中.png";
import hoverimg3 from "@/assets1/首页_slices (1)/公益商城选中.png";
export default {
  components: {
    Serve,
    Hzhb,
  },
  computed: {
    Hoverimg() {
      if (this.index !== null) {
        const list = [hoverimg1, hoverimg2, hoverimg3];
        return `url(${list[this.index]})`;
      }
    },
  },
  data() {
    return {
      logo: logo,
      index: null,
      data: [
        {
          title: "数字镖局",
          go:'/szbj',
          content:
            "数字镖局基于区块链和隐私加密计算技术构建,是数据可信存储、可信传输的平台. 主要解决企业(机构)内部, 跨企业(机构)之间数据可信传输共享的问题.",
          img: img1,
        },
        {
          title: "数匣",
          go:'/sx',
          content:
            "数匣是面向个人拥护的安全数据存储应用, 数匣为用户提供了专属的数据保险箱, 让用户完全掌握自己的个人数据空间.",
          img: img2,
        },
        {
          title: "数据集超市",
          go:'Dataset',
          content:
            "数据集超市, 是为数据资源提供价值流通的平台. 为数据需求方和数据提供方提供透明、简洁、可信的合作平台.",
          img: img3,
        },
      ],
    };
  },
  methods: {
    handlehover(index) {
      this.index = index;
    },
    handlemk() {
      this.$router.push("/Dataset");
    },
    handlepush(go){
        this.$router.push(go)
    }
  },
};
</script>

<style scoped>
.bgImg {
  width: 64px;
  height: 64px;
  margin-top: 70px;
}
@keyframes jump {
  0% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(0px);
  }
}
.icon-shubiao:hover {
  animation: jump 1s infinite ease-in-out;
}
.product-item:hover {
  /* background: linear-gradient(to top, rgba(56,96,244,0.6) 0%, rgba(13,56,216,0.95) 100%); */
  background-image: url("../../assets1/首页_slices (1)/分组 7(2).png");
  border: none;
  /* object-fit: cover; */
  background-size: 100%;
}

.product-item:hover .item-content {
  color: #fff;
}
.product-item:hover .item-title {
  color: #fff;
}
.product-item:hover > .item-ornament {
  background-color: #3759e2;
}
.product-item:hover .bgImg {
  content: v-bind(Hoverimg);
}
.products-List {
  display: flex;
  justify-content: center;
  text-align: center;
}
.HomeView-container {
  min-width: 1920px;
  min-height: 1080px;
  /* background-image: url("../../assets1/首页_slices (1)/首屏背景.png"); */
  background-image: url("https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E9%A6%96%E5%B1%8F%E8%83%8C%E6%99%AF.png");
  background-size: cover;
  position: relative;
}
.bg-Mask {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(1, 7, 37, 0.3);
}
.body {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #fff;
}
.body img {
  width: 87px;
  height: 120px;
  object-fit: cover;
}
.body h1 {
  margin-top: 30px;
  font-family: Heavy;
  font-weight: 800;
  font-size: 56px;
  color: #ffffff;
  line-height: 77px;
  height: 77px;
  font-style: normal;
  margin-bottom: 20px;
}
strong {
  font-weight: 900;

  letter-spacing: 2px;
}
.body h2 {
  font-family: Light;
  font-weight: 400;
  font-size: 30px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 42px;
  letter-spacing: 5px;

  font-style: normal;
  margin-bottom: 142px;
}
.btnList {
  display: flex;
  justify-content: space-between;
}
.btnList a {
  width: 200px;
  height: 56px;
  background: #0d53ff;
  border-radius: 12px;
  line-height: 56px;
  text-align: center;
  font-family: Light;
  font-weight: 400;
  font-size: 20px;
  color: #fff;
  cursor: pointer;

  font-style: normal;
}
.mouse {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 25px;
  color: #edeeff;
  text-align: center;
}
.icon-shubiao {
  font-size: 45px;
  transform: translateY(0px);
  cursor: pointer;
  display: inline-block;
}
.mouse p {
  margin-top: 10px;
  font-size: 14px;
  letter-spacing: 1px;
  font-family: Light;
  font-weight: 300;
}
.hxcp {
  padding: 40px;
  min-width: 1920px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  text-align: center;
}
.hxcp-title {
  margin-top: 100px;
  margin-bottom: 60px;
  font-family: Medium;
  font-weight: 500;
  font-size: 36px;
  color: #17213c;
  line-height: 54px;
}
.icon-a-baoxianxiangbaoguancaijing {
  color: #000;
  font-size: 52px;
}
.product-item {
  width: 380px;
  height: 380px;
  /* box-shadow: 0px 0px 1px rgba(0, 0, 0, .3); */

  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  text-align: center;
  padding: 10px 40px;
  position: relative;
  background-color: #fff;
  margin-right: 20px;
  margin-bottom: 40px;
  background-image: url("../../assets1/首页_slices (1)/分组 7.png");
  background-size: cover;
  cursor: pointer;
}
.product-item:last-child {
  margin-right: 0px;
}
.item-title {
  /* margin-top: 50px;
    font-size: 17px;
    font-weight: 500;
    margin-bottom: 18px; */
  margin-top: 20px;
  font-family: Medium;
  font-weight: 500;
  font-size: 20px;
  height: 48px;
  color: #17213c;
  line-height: 48px;
  text-align: right;
  font-style: normal;
}
.item-content {
  font-family: Regular;
  font-weight: 300;
  font-size: 16px;
  color: #838690;
  line-height: 26px;
  font-style: normal;
}
.item-ornament {
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #000;
  z-index: -3;
}
.Mask {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}
.item1 {
  left: -3px;
  top: -3px;
}
.item2 {
  right: -3px;
  top: -3px;
}
.item3 {
  left: -3px;
  bottom: -3px;
}
.item4 {
  right: -3px;
  bottom: -3px;
}
</style>